/* TODO: think about filters VS. applied values structure,
options could be separate state since they will be reused in many places */
import { combineReducers } from 'redux';
import {
  TALENT_FILTERS_SET_SEARCH_MODE,
  TALENT_FILTERS_SET_SEARCH_ID,
  TALENT_FILTERS_SET_SEARCH_FIRST_NAME,
  TALENT_FILTERS_SET_SEARCH_LAST_NAME,
  TALENT_FILTERS_SET_SEARCH_EMAIL,
  TALENT_FILTERS_RESET_SEARCH,
  TALENT_FILTERS_SET_TALENTS_MODE,
} from '../types/talentFiltersTypes';

import { TALENTS_MODE } from '../../config/consts';

export const initialState = {
  talentsMode: TALENTS_MODE.filters,
  search: {
    mode: 'id',
    id: '',
    firstName: '',
    lastName: '',
    email: '',
  },
};

const talentsModeReducer = (state = initialState.talentsMode, action) => {
  switch (action.type) {
    case TALENT_FILTERS_SET_TALENTS_MODE:
      return action.payload;
    default:
      return state;
  }
};

const searchReducer = (state = initialState.search, action) => {
  switch (action.type) {
    case TALENT_FILTERS_SET_SEARCH_MODE:
      return { ...state, mode: action.payload };
    case TALENT_FILTERS_SET_SEARCH_ID:
      return { ...state, id: action.payload };
    case TALENT_FILTERS_SET_SEARCH_FIRST_NAME:
      return { ...state, firstName: action.payload };
    case TALENT_FILTERS_SET_SEARCH_LAST_NAME:
      return { ...state, lastName: action.payload };
    case TALENT_FILTERS_SET_SEARCH_EMAIL:
      return { ...state, email: action.payload };
    case TALENT_FILTERS_RESET_SEARCH:
      return {
        ...state,
        id: '',
        firstName: '',
        lastName: '',
        email: '',
      };
    default:
      return state;
  }
};

const talentfiltersReducer = combineReducers({
  talentsMode: talentsModeReducer,
  search: searchReducer,
});

export default talentfiltersReducer;
